import { BaseElement, ElementTypesEnum } from '@frontend/editor/interface';
import { Edge, MarkerType } from 'reactflow';

/**
 * 判斷是否為留言自動回覆畫布（IG/Threads 官方模板）：
 * 只有這類 chart 會有私訊起點 / 留言起點 block，一般 FB/Messenger flow 不會出現
 */
export const isCommentReplyChart = (
  elements: Pick<BaseElement, 'elementType'>[],
) =>
  elements.some(
    (el) =>
      el.elementType === ElementTypesEnum.INSTAGRAM_PRIVATE_REPLY ||
      el.elementType === ElementTypesEnum.COMMENT_REPLY_BLOCK,
  );

export const getEdge = (
  source: BaseElement,
  target: BaseElement,
  // 留言自動回覆畫布不開放使用者操作連線，block 級 edge 僅顯示、不可拖曳改接
  isCommentReplyCanvas = false,
) => {
  let newEdge: Edge;
  if (source.nodeID) {
    // 只有在內層的元素才會有 node id
    newEdge = {
      id: source.outputID,
      source: source.nodeID as string,
      sourceHandle: source.outputID,
      target: target.id,
      targetHandle: target.inputID,
      updatable: 'target',
      markerEnd: {
        type: MarkerType.ArrowClosed,
      },
    };
  } else {
    // 如果找不到代表是最外層的 node，sourceID 會是 elementID
    newEdge = {
      id: source.outputID,
      source: source.id,
      // 補上 handle id：node 若沒渲染任何 source handle，ReactFlow 會靜默丟棄 edge（error 008），
      // 造成官方模板的 block 級連線（如私訊起點→追蹤檢查）在畫布上看不到
      sourceHandle: source.outputID,
      target: target.id,
      targetHandle: target.inputID,
      // WHY：留言回覆畫布的 block 級邊一律鎖 updatable——含 template editor（可刪邊重畫）；
      // 2026-07-30 review 決議接受此鎖定，避免區分 template 模式增加狀態耦合
      updatable: isCommentReplyCanvas ? false : 'target',
      markerEnd: {
        type: MarkerType.ArrowClosed,
      },
    };
  }
  return newEdge;
};
